export {default as Uranus} from './models/Uranus';
